export const getChartOptions = () => {
  return {
    legend: {
      display: true,
      labels: {
        padding: 2,
        boxWidth: 20,
      },
    },

    layout: {
      padding: 5,
    },
    responsive: true,
    maintainAspectRatio: true,
  };
};
